import dateFormat from "dateformat";
import { t } from "i18next";

const getTimeLeft = (endtime: Date | number | string) => {
  const timeNow = new Date();
  const targetDate = new Date(endtime);
  return targetDate.getTime() - timeNow.getTime();
};

export const getTimeDuration = (
  startTime: Date | number | string,
  endtime?: Date,
) => {
  const startDate = new Date(startTime);
  const endDate = !endtime ? new Date() : new Date(endtime);
  return Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
};

export const countDownDate = (endtime?: Date | number | string) => {
  if (!endtime) return "";
  const timeLeft = getTimeLeft(endtime);
  if (timeLeft < 0) return t("ended");

  const minutes: string | number = Math.floor((timeLeft / 1000 / 60) % 60);
  const hours: string | number = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  const days: string | number = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

  if (days > 0) {
    return `${days}d ${hours}h`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};

export const formatDate = (
  date: Date | string | number,
  formatType: string,
) => {
  const fDate = new Date(date);
  const diffDays = new Date().getDate() - fDate.getDate();
  const diffMonths = new Date().getMonth() - fDate.getMonth();
  const diffYears = new Date().getFullYear() - fDate.getFullYear();

  if (diffDays === 0 && diffMonths === 0 && diffYears === 0) {
    return t("today");
  }
  return dateFormat(date, formatType);
};
